const gender_options = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" },
  ];
  
  const ethnicity_options = [
    { label: "Black", value: "black" },
    { label: "White", value: "white" },
    { label: "Mixed", value: "mixed" },
    { label: "Asian", value: "Asian" },
    { label: "Indian", value: "indian" },
    { label: "Unknown", value: "unknown" },
  ];
  
  const marital_status_options = [
    { label: "Single", value: "single" },
    { label: "Married", value: "married" },
    { label: "Divorced", value: "divorced" },
    { label: "Widowed", value: "widowed" },
    { label: "Seperated", value: "seperated" },
  ];
  
  const education_level_options = [
    { label: "Primary", value: "primary" },
    { label: "Secondary", value: "secondary" },
    { label: "High School", value: "high_school" },
    { label: "Tertiary (College/ University)", value: "tertiary_(college/ university)" },
    { label: "No Education", value: "no_education" },
  ];
  
  const patient_regions_options = [
    {label: "Hhohho", value: "Hhohho"},
    {label: "Lubombo", value: "Lubombo"},
    {label: "Manzini", value: "Manzini"},
    {label: "Shiselweni", value: "Shiselweni"},
  ];
  
  const occupation_options = [
    { label: "Agriculture and Forestry", value: "agriculture_and_forestry" },
    { label: "Army Service", value: "army_service" },
    { label: "Art, Media and Communications", value: "art_media_and_communications" },
    { label: "Business", value: "business" },
    { label: "Civil Service", value: "civil_service" },
    { label: "Community Service", value: "community_service" },
    { label: "Construction and Engineering", value: "construction_and_engineering" },
    { label: "Correctional Service", value: "correctional_service" },
    { label: "Domestic Workers", value: "domestic_workers" },
    { label: "Education", value: "education" },
    { label: "Electricity and Water", value: "electricity_and_water" },
    { label: "Energy and Oil", value: "energy_and_oil" },
    { label: "Finance", value: "finance" },
    { label: "Fire Services", value: "fire_services" },
    { label: "Health Care Worker", value: "health_care_worker" },
    { label: "Healthcare", value: "healthcare" },
    { label: "Hospitality and Food", value: "hospitality_and_food" },
    { label: "Information Traders", value: "information_traders" },
    { label: "Information and Technology", value: "information_and_technology" },
    { label: "Legal Sector", value: "legal_sector" },
    { label: "Manufacturing", value: "manufacturing" },
    { label: "Marketing and Sales", value: "marketing_and_sales" },
    { label: "Mining", value: "mining" },
    { label: "Motoring Industry", value: "motoring_industry" },
    { label: "NGO", value: "ngo" },
    { label: "Other", value: "other" },
    { label: "Other Human Services", value: "other_human_services" },
    { label: "Paramedic", value: "paramedic" },
    { label: "Police and Correctional Services", value: "police_and_correctional_services" },
    { label: "Police Service", value: "police_service" },
    { label: "Professional Service Industry", value: "professional_service_industry" },
    { label: "Property and Real Estate", value: "property_and_real_estate" },
    { label: "Religious Worker", value: "religious_worker" },
    { label: "Retail and Wholesale", value: "retail_and_wholesale" },
    { label: "Retirees", value: "retirees" },
    { label: "Science Industries", value: "science_industries" },
    { label: "Student", value: "student" },
    { label: "Textile Industry", value: "textile_industry" },
    { label: "Tourism", value: "tourism" },
    { label: "Traditional Leaders", value: "traditional_leaders" },
    { label: "Transportation", value: "transportation" },
    { label: "Unemployed", value: "unemployed" },
  ];
  
  const client_is_handicapped_options = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];
  
  const country_of_origin_options = [
    { label: "Kingdom of Eswatini", value: "Kingdom of Eswatini" },
    { label: "Afghanistan", value: "Afghanistan" },
    { label: "Albania", value: "Albania" },
    { label: "Algeria", value: "Algeria" },
    { label: "Andorra", value: "Andorra" },
    { label: "Angola", value: "Angola" },
    { label: "Antigua and Barbuda", value: "Antigua and Barbuda" },
    { label: "Argentina", value: "Argentina" },
    { label: "Armenia", value: "Armenia" },
    { label: "Australia", value: "Australia" },
    { label: "Austria", value: "Austria" },
    { label: "Azerbaijan", value: "Azerbaijan" },
    { label: "Bahamas", value: "Bahamas" },
    { label: "Bahrain", value: "Bahrain" },
    { label: "Bangladesh", value: "Bangladesh" },
    { label: "Barbados", value: "Barbados" },
    { label: "Belarus", value: "Belarus" },
    { label: "Belgium", value: "Belgium" },
    { label: "Belize", value: "Belize" },
    { label: "Benin", value: "Benin" },
    { label: "Bhutan", value: "Bhutan" },
    { label: "Bolivia", value: "Bolivia" },
    { label: "Botswana", value: "Botswana" },
    { label: "Brazil", value: "Brazil" },
    { label: "Brunei", value: "Brunei" },
    { label: "Bulgaria", value: "Bulgaria" },
    { label: "Burkina Faso", value: "Burkina Faso" },
    { label: "Burundi", value: "Burundi" },
    { label: "Cabo Verde", value: "Cabo Verde" },
    { label: "Cambodia", value: "Cambodia" },
    { label: "Cameroon", value: "Cameroon" },
    { label: "Canada", value: "Canada" },
    { label: "Central African Republic", value: "Central African Republic" },
    { label: "Chad", value: "Chad" },
    { label: "Chile", value: "Chile" },
    { label: "China", value: "China" },
    { label: "Colombia", value: "Colombia" },
    { label: "Comoros", value: "Comoros" },
    { label: "Democratic Republic of Congo", value: "Democratic Republic of Congo" },
    { label: "Costa Rica", value: "Costa Rica" },
    { label: "Cote d'Ivoire", value: "Cote d'Ivoire" },
    { label: "Croatia", value: "Croatia" },
    { label: "Cuba", value: "Cuba" },
    { label: "Cyprus", value: "Cyprus" },
    { label: "Czech Republic", value: "Czech Republic" },
    { label: "Denmark", value: "Denmark" },
    { label: "Djibouti", value: "Djibouti" },
    { label: "Dominica", value: "Dominica" },
    { label: "Dominican Republic", value: "Dominican Republic" },
    { label: "Ecuador", value: "Ecuador" },
    { label: "Egypt", value: "Egypt" },
    { label: "El Salvador", value: "El Salvador" },
    { label: "Equatorial Guinea", value: "Equatorial Guinea" },
    { label: "Eritrea", value: "Eritrea" },
    { label: "Estonia", value: "Estonia" },
    { label: "Ethiopia", value: "Ethiopia" },
    { label: "Fiji", value: "Fiji" },
    { label: "Finland", value: "Finland" },
    { label: "France", value: "France" },
    { label: "Gabon", value: "Gabon" },
    { label: "Gambia", value: "Gambia" },
    { label: "Georgia", value: "Georgia" },
    { label: "Germany", value: "Germany" },
    { label: "Ghana", value: "Ghana" },
    { label: "Greece", value: "Greece" },
    { label: "Grenada", value: "Grenada" },
    { label: "Guatemala", value: "Guatemala" },
    { label: "Guinea", value: "Guinea" },
    { label: "Guinea Bissau", value: "Guinea Bissau" },
    { label: "Guyana", value: "Guyana" },
    { label: "Haiti", value: "Haiti" },
    { label: "Honduras", value: "Honduras" },
    { label: "Hungary", value: "Hungary" },
    { label: "Iceland", value: "Iceland" },
    { label: "India", value: "India" },
    { label: "Indonesia", value: "Indonesia" },
    { label: "Iran", value: "Iran" },
    { label: "Iraq", value: "Iraq" },
    { label: "Ireland", value: "Ireland" },
    { label: "Israel", value: "Israel" },
    { label: "Italy", value: "Italy" },
    { label: "Jamaica", value: "Jamaica" },
    { label: "Japan", value: "Japan" },
    { label: "Jordan", value: "Jordan" },
    { label: "Kazakhstan", value: "Kazakhstan" },
    { label: "Kenya", value: "Kenya" },
    { label: "Kiribati", value: "Kiribati" },
    { label: "Kosovo", value: "Kosovo" },
    { label: "Kuwait", value: "Kuwait" },
    { label: "Kyrgyzstan", value: "Kyrgyzstan" },
    { label: "Laos", value: "Laos" },
    { label: "Latvia", value: "Latvia" },
    { label: "Lebanon", value: "Lebanon" },
    { label: "Lesotho", value: "Lesotho" },
    { label: "Liberia", value: "Liberia" },
    { label: "Libya", value: "Libya" },
    { label: "Liechtenstein", value: "Liechtenstein" },
    { label: "Lithuania", value: "Lithuania" },
    { label: "Luxembourg", value: "Luxembourg" },
    { label: "Macedonia", value: "Macedonia" },
    { label: "Madagascar", value: "Madagascar" },
    { label: "Malawi", value: "Malawi" },
    { label: "Malaysia", value: "Malaysia" },
    { label: "Maldives", value: "Maldives" },
    { label: "Mali", value: "Mali" },
    { label: "Malta", value: "Malta" },
    { label: "Marshall Islands", value: "Marshall Islands" },
    { label: "Mauritania", value: "Mauritania" },
    { label: "Mauritius", value: "Mauritius" },
    { label: "Mexico", value: "Mexico" },
    { label: "Micronesia", value: "Micronesia" },
    { label: "Moldova", value: "Moldova" },
    { label: "Monaco", value: "Monaco" },
    { label: "Mongolia", value: "Mongolia" },
    { label: "Montenegro", value: "Montenegro" },
    { label: "Morocco", value: "Morocco" },
    { label: "Mozambique", value: "Mozambique" },
    { label: "Myanmar", value: "Myanmar" },
    { label: "Namibia", value: "Namibia" },
    { label: "Nauru", value: "Nauru" },
    { label: "Nepal", value: "Nepal" },
    { label: "Netherlands", value: "Netherlands" },
    { label: "New Zealand", value: "New Zealand" },
    { label: "Nicaragua", value: "Nicaragua" },
    { label: "Niger", value: "Niger" },
    { label: "Nigeria", value: "Nigeria" },
    { label: "North Korea", value: "North Korea" },
    { label: "Norway", value: "Norway" },
    { label: "Oman", value: "Oman" },
    { label: "Pakistan", value: "Pakistan" },
    { label: "Palau", value: "Palau" },
    { label: "Palestine", value: "Palestine" },
    { label: "Panama", value: "Panama" },
    { label: "Papua New Guinea", value: "Papua New Guinea" },
    { label: "Paraguay", value: "Paraguay" },
    { label: "Peru", value: "Peru" },
    { label: "Philippines", value: "Philippines" },
    { label: "Poland", value: "Poland" },
    { label: "Portugal", value: "Portugal" },
    { label: "Qatar", value: "Qatar" },
    { label: "Romania", value: "Romania" },
    { label: "Russia", value: "Russia" },
    { label: "Rwanda", value: "Rwanda" },
    { label: "Saint Lucia", value: "Saint Lucia" },
    { label: "Samoa", value: "Samoa" },
    { label: "San Marino", value: "San Marino" },
    { label: "Saudi Arabia", value: "Saudi Arabia" },
    { label: "Senegal", value: "Senegal" },
    { label: "Serbia", value: "Serbia" },
    { label: "Seychelles", value: "Seychelles" },
    { label: "Sierra Leone", value: "Sierra Leone" },
    { label: "Singapore", value: "Singapore" },
    { label: "Slovakia", value: "Slovakia" },
    { label: "Slovenia", value: "Slovenia" },
    { label: "Solomon Islands", value: "Solomon Islands" },
    { label: "Somalia", value: "Somalia" },
    { label: "South Africa", value: "South Africa" },
    { label: "South Korea", value: "South Korea" },
    { label: "South Sudan", value: "South Sudan" },
    { label: "Spain", value: "Spain" },
    { label: "Sri Lanka", value: "Sri Lanka" },
    { label: "Sudan", value: "Sudan" },
    { label: "Suriname", value: "Suriname" },
    { label: "Sweden", value: "Sweden" },
    { label: "Switzerland", value: "Switzerland" },
    { label: "Syria", value: "Syria" },
    { label: "Taiwan", value: "Taiwan" },
    { label: "Tajikistan", value: "Tajikistan" },
    { label: "Tanzania", value: "Tanzania" },
    { label: "Thailand", value: "Thailand" },
    { label: "Timor Leste", value: "Timor Leste" },
    { label: "Togo", value: "Togo" },
    { label: "Tonga", value: "Tonga" },
    { label: "Trinidad and Tobago", value: "Trinidad and Tobago" },
    { label: "Tunisia", value: "Tunisia" },
    { label: "Turkey", value: "Turkey" },
    { label: "Turkmenistan", value: "Turkmenistan" },
    { label: "Tuvalu", value: "Tuvalu" },
    { label: "Uganda", value: "Uganda" },
    { label: "Ukraine", value: "Ukraine" },
    { label: "United Arab Emirates", value: "United Arab Emirates" },
    { label: "United Kingdom", value: "United Kingdom" },
    { label: "United States of America", value: "United States of America" },
    { label: "Uruguay", value: "Uruguay" },
    { label: "Uzbekistan", value: "Uzbekistan" },
    { label: "Vanuatu", value: "Vanuatu" },
    { label: "Vatican City", value: "Vatican City" },
    { label: "Venezuela", value: "Venezuela" },
    { label: "Vietnam", value: "Vietnam" },
    { label: "Yemen", value: "Yemen" },
    { label: "Zambia", value: "Zambia" },
    { label: "Zimbabwe", value: "Zimbabwe" },
  ];
  
  const inkhulda_options = [
    { label: "Kukhanyeni", value: "kukhanyeni" },
    { label: "Mtfongwaneni", value: "mtfongwaneni" },
    { label: "Mahlangatsha", value: "mahlangatsha" },
    { label: "Mangcongco", value: "mangcongco" },
    { label: "Ludzeludze", value: "ludzeludze" },
    { label: "Emikhiweni", value: "emikhiweni" },
    { label: "Lobamba Lomdzala", value: "lobamba lomdzala" },
    { label: "Matsanjeni", value: "matsanjeni" },
    { label: "Ntontozi", value: "ntontozi" },
    { label: "Lamgabhi", value: "lamgabhi" },
    { label: "Mafutseni", value: "mafutseni" },
    { label: "Nhlambeni", value: "nhlambeni" },
    { label: "Ngwempisi", value: "ngwempisi" },
    { label: "Mhlambanyatsi", value: "mhlambanyatsi" },
    { label: "Manzini North", value: "manzini north" },
    { label: "Manzini South", value: "manzini south" },
    { label: "Kwaluseni", value: "kwaluseni" },
    { label: "Sigwe", value: "sigwe" },
    { label: "Ngudzeni", value: "ngudzeni" },
    { label: "Khubuta", value: "khubuta" },
    { label: "Mtsambama", value: "mtsambama" },
    { label: "Gege", value: "gege" },
    { label: "Shiselweni 1", value: "shiselweni 1" },
    { label: "Shiselweni 2", value: "shiselweni 2" },
    { label: "Sandleni", value: "sandleni" },
    { label: "Hosea", value: "hosea" },
    { label: "Nkomiyahlaba", value: "nkomiyahlaba" },
    { label: "Nkwene", value: "nkwene" },
    { label: "Maseyisini", value: "maseyisini" },
    { label: "Somntongo", value: "somntongo" },
    { label: "Sithobela", value: "sithobela" },
    { label: "Mpholonjeni", value: "mpholonjeni" },
    { label: "Siphofaneni", value: "siphofaneni" },
    { label: "Nkilongo", value: "nkilongo" },
    { label: "Matsanjeni North", value: "matsanjeni north" },
    { label: "Dvokodvweni", value: "dvokodvweni" },
    { label: "Lubuli", value: "lubuli" },
    { label: "Hlane", value: "hlane" },
    { label: "Lomahasha", value: "lomahasha" },
    { label: "Mhlume", value: "mhlume" },
    { label: "Lugongolweni", value: "lugongolweni" },
    { label: "Timphisini", value: "timphisini" },
    { label: "Ndzingeni", value: "ndzingeni" },
    { label: "Mhlangatane", value: "mhlangatane" },
    { label: "Ntfonjeni", value: "ntfonjeni" },
    { label: "Pigg's Peak", value: "pigg's peak" },
    { label: "Madlangempisi", value: "madlangempisi" },
    { label: "Lobamba", value: "lobamba" },
    { label: "Mbabane West", value: "mbabane west" },
    { label: "Mbabane East", value: "mbabane east" },
    { label: "Hhukwini", value: "hhukwini" },
    { label: "Maphalaleni", value: "maphalaleni" },
    { label: "Motshane", value: "motshane" },
    { label: "Nkhaba", value: "nkhaba" },
    { label: "Mayiwane", value: "mayiwane" },
    { label: "Zombodze Emuva", value: "zombodze emuva" },
    { label: "Matsanjeni", value: "matsanjeni" },
  ];
  
  const chiefdom_options = {
    lobamba: [
      { label: "Elangeni", value: "elangeni" },
      { label: "Ezabeni", value: "ezabeni" },
      { label: "Ezulwini", value: "ezulwini" },
      { label: "Lobamba", value: "lobamba" },
      { label: "Nkhanini/Sitjeni", value: "nkhanini/sitjeni" },
    ],
    madlangempisi: [
      { label: "Ejubukweni", value: "ejubukweni" },
      { label: "Mdzimba", value: "mdzimba" },
      { label: "Malanti", value: "malanti" },
      { label: "Nkhaba", value: "nkhaba" },
      { label: "Ndzingeni", value: "ndzingeni" },
      { label: "Bulandzeni", value: "bulandzeni" },
      { label: "Kwaliweni/Nkonyeni", value: "kwaliweni/nkonyeni" },
      { label: "Ludlawini", value: "ludlawini" },
      { label: "Mgungundlovu", value: "mgungundlovu" },
      { label: "Mvuma", value: "mvuma" },
      { label: "Nkamanzi", value: "nkamanzi" },
      { label: "Meleti", value: "meleti" },
      { label: "Ntsanjeni", value: "ntsanjeni" },
    ],
    mayiwane: [
      { label: "Herefords", value: "herefords" },
      { label: "Mfasini", value: "mfasini" },
      { label: "Mavula", value: "mavula" },
      { label: "Mkhuzweni", value: "mkhuzweni" },
      { label: "Mkhweni", value: "mkhweni" },
    ],
    ntfonjeni: [
      { label: "Emvembili", value: "emvembili" },
      { label: "Evusweni", value: "evusweni" },
      { label: "KaHhelehhele", value: "kahhelehhele" },
      { label: "KaHhohho", value: "kahhohho" },
      { label: "KaLomshiyo", value: "kalomshiyo" },
      { label: "KaNdwandwe", value: "kandwandwe" },
      { label: "Mshingishingin", value: "mshingishingin" },
    ],
    "pigg's peak": [
      { label: "Bulembu/Luhhumaneni 1", value: "bulembu/luhhumaneni 1" },
      { label: "Luhhumaneni / KaNdeva", value: "luhhumaneni / kandeva" },
      { label: "Luhlangotsini", value: "luhlangotsini" },
      { label: "Nginamadolo", value: "nginamadolo" },
      { label: "Nsangwini", value: "nsangwini" },
      { label: "Pigg's Peak", value: "pigg's peak" },
    ],
    motshane: [
      { label: "Kupheleni", value: "kupheleni" },
      { label: "Mpolonjeni", value: "mpolonjeni" },
      { label: "Nduma", value: "nduma" },
    ],
    nkhaba: [
      { label: "Ejubukweni", value: "ejubukweni" },
      { label: "Ekuvinjelweni", value: "ekuvinjelweni" },
      { label: "Mdzimba", value: "mdzimba" },
      { label: "Malanti", value: "malanti" },
      { label: "Nkhaba", value: "nkhaba" },
    ],
    hhukwini: [
      { label: "Dlangeni", value: "dlangeni" },
      { label: "Lamgabhi", value: "lamgabhi" },
      { label: "Kasiko", value: "kasiko" },
      { label: "Sitseni", value: "sitseni" },
    ],
    maphalaleni: [
      { label: "Endlozini", value: "endlozini" },
      { label: "Emfeni", value: "emfeni" },
      { label: "Emcengeni", value: "emcengeni" },
      { label: "Ensingweni", value: "ensingweni" },
      { label: "Madlolo", value: "madlolo" },
      { label: "Maphalaleni", value: "maphalaleni" },
    ],
    mhlangatane: [
      { label: "Malibeni", value: "malibeni" },
      { label: "Mangweni", value: "mangweni" },
      { label: "Mpofu", value: "mpofu" },
      { label: "Ndwabangeni", value: "ndwabangeni" },
      { label: "Nhlanguyavuka", value: "nhlanguyavuka" },
      { label: "Nyakatfo", value: "nyakatfo" },
      { label: "Sidwashini", value: "sidwashini" },
      { label: "Zinyane", value: "zinyane" },
    ],
    timphisini: [
      { label: "Hhohho", value: "hhohho" },
      { label: "Ludzibini", value: "ludzibini" },
      { label: "Mashobeni North", value: "mashobeni north" },
      { label: "Mvembili", value: "mvembili" },
    ],
    "mbabane west": [
      { label: "Mangwaneni", value: "mangwaneni" },
      { label: "Manzana", value: "manzana" },
      { label: "Nkwalini", value: "nkwalini" },
    ],
    "mbabane east": [
      { label: "Fonteyn", value: "fonteyn" },
      { label: "Mdzimba/Lofokati", value: "mdzimba/lofokati" },
      { label: "Msunduza", value: "msunduza" },
      { label: "Sidwashini", value: "sidwashini" },
    ],
    siphocosini: [
      { label: "Siphocosini", value: "siphocosini" },
      { label: "Mantabeni", value: "mantabeni" },
      { label: "Sigangeni", value: "sigangeni" },
      { label: "Luhlendlweni", value: "luhlendlweni" },
    ],
    ludzeludze: [
      { label: "Kudzeni", value: "kudzeni" },
      { label: "Mbekelweni", value: "mbekelweni" },
      { label: "Nkamanzi", value: "nkamanzi" },
      { label: "Zombodze", value: "zombodze" },
      { label: "Lozitha", value: "lozitha" },
    ],
    kukhanyeni: [
      { label: "Bhekinkhosi", value: "bhekinkhosi" },
      { label: "Maliyaduma", value: "maliyaduma" },
      { label: "Mbeka", value: "mbeka" },
      { label: "Mkhulamini", value: "mkhulamini" },
      { label: "Nkiliji", value: "nkiliji" },
      { label: "Nswaceni", value: "nswaceni" },
      { label: "Nyakeni", value: "nyakeni" },
    ],
    emikhiweni: [
      { label: "Dvokolwako", value: "dvokolwako" },
      { label: "Khuphuka/ Ngomane", value: "khuphuka/ngomane" },
      { label: "Kutsimleni", value: "kutsimleni" },
      { label: "Mbelebeleni", value: "mbelebeleni" },
      { label: "Mnjoli /Likima", value: "mnjoli/likima" },
    ],
    mtfongwaneni: [
      { label: "Gundvwini/ Lesibovu", value: "gundvwini/lesibovu" },
      { label: "Hlane/ Bulunga", value: "hlane/bulunga" },
      { label: "Lwandle", value: "lwandle" },
      { label: "Ndlandlameni", value: "ndlandlameni" },
    ],
    mafutseni: [
      { label: "Bhudla", value: "bhudla" },
      { label: "Ka-Nkambule", value: "ka-nkambule" },
      { label: "Luhlokohla", value: "luhlokohla" },
      { label: "Mafutseni", value: "mafutseni" },
      { label: "Ngculwini", value: "ngculwini" },
      { label: "Timbutini", value: "timbutini" },
    ],
    lamgabhi: [
      { label: "Dvudvusini", value: "dvudvusini" },
      { label: "Lamgabhi", value: "lamgabhi" },
      { label: "Luhleko", value: "luhleko" },
      { label: "Emhlangeni", value: "emhlangeni" },
      { label: "Nhlulweni", value: "nhlulweni" },
    ],
    mhlambanyatsi: [
      { label: "Bhunya", value: "bhunya" },
      { label: "Dingizwe", value: "dingizwe" },
      { label: "Lundzi", value: "lundzi" },
      { label: "Mbangave", value: "mbangave" },
      { label: "Mlindazwe", value: "mlindazwe" },
      { label: "Zondwako", value: "zondwako" },
    ],
    mangcongco: [
      { label: "Dwalile", value: "dwalile" },
      { label: "Mabhukwini", value: "mabhukwini" },
      { label: "Mangcongco", value: "mangcongco" },
      { label: "Sandlane/ Ekuthuleni", value: "sandlane/ekuthuleni" },
    ],
    ngwempisi: [
      { label: "Bhadzeni 1", value: "bhadzeni 1" },
      { label: "Dladleni", value: "dladleni" },
      { label: "Macudvulwini", value: "macudvulwini" },
      { label: "Ngcoseni", value: "ngcoseni" },
      { label: "Velezizweni", value: "velezizweni" },
    ],
    mahlangatsha: [
      { label: "Bhahwini", value: "bhahwini" },
      { label: "Ka-Zulu", value: "ka-zulu" },
      { label: "Ludvondvolweni", value: "ludvondvolweni" },
      { label: "Luzelweni/ Ntfungula", value: "luzelweni/ntfungula" },
      { label: "Mambatfweni", value: "mambatfweni" },
      { label: "Mgofelweni", value: "mgofelweni" },
      { label: "Mpholonjeni/ Mahlangatsha", value: "mpholonjeni/mahlangatsha" },
      { label: "Nciniselweni", value: "nciniselweni" },
      { label: "Ndzeleni", value: "ndzeleni" },
      { label: "Nsangwini", value: "nsangwini" },
      { label: "Sigcineni", value: "sigcineni" },
    ],
    "manzini north": [
      { label: "Dwaleni", value: "dwaleni" },
      { label: "Emakholweni", value: "emakholweni" },
      { label: "Manzini Central", value: "manzini central" },
      { label: "Mnyenyweni", value: "mnyenyweni" },
      { label: "Mzimnene", value: "mzimnene" },
      { label: "St. Pauls", value: "st. pauls" },
    ],
    "manzini south": [
      { label: "Mjingo", value: "mjingo" },
      { label: "Moneni", value: "moneni" },
      { label: "Mhobodleni", value: "mhobodleni" },
      { label: "Ngwane Park", value: "ngwane park" },
      { label: "Ticancweni", value: "ticancweni" },
      { label: "Zakhele", value: "zakhele" },
    ],
    nhlambeni: [
      { label: "Ngonini", value: "ngonini" },
      { label: "Njelu", value: "njelu" },
      { label: "Masundvwini", value: "masundvwini" },
      { label: "Mphankhomo", value: "mphankhomo" },
    ],
    kwaluseni: [
      { label: "Kwaluseni", value: "kwaluseni" },
      { label: "Logoba", value: "logoba" },
      { label: "Mhlane", value: "mhlane" },
    ],
    "lobamba lomdzala": [
      { label: "Kufinyeni", value: "kufinyeni" },
      { label: "Luyengo", value: "luyengo" },
      { label: "Mahlanya", value: "mahlanya" },
      { label: "Ngwenyameni", value: "ngwenyameni" },
    ],
    ntontozi: [
      { label: "Gebeni", value: "gebeni" },
      { label: "Khalangilile/Luyengo", value: "khalangilile/luyengo" },
      { label: "Mphini", value: "mphini" },
      { label: "Ncabaneni", value: "ncabaneni" },
      { label: "Ndinda", value: "ndinda" },
      { label: "Ndlinilembi", value: "ndlinilembi" },
      { label: "Ntontozi", value: "ntontozi" },
    ],
    phondo: [
      { label: "Bhadzeni 2", value: "bhadzeni 2" },
      { label: "Lushikishini", value: "lushikishini" },
      { label: "Khabonina", value: "khabonina" },
      { label: "Mahhashini", value: "mahhashini" },
      { label: "Mgazini", value: "mgazini" },
    ],
    nkomiyahlaba: [
      { label: "Eni", value: "eni" },
      { label: "Ngcayini", value: "ngcayini" },
      { label: "Nsenga", value: "nsenga" },
      { label: "Nsingweni", value: "nsingweni" },
      { label: "Sankolweni", value: "sankolweni" },
      { label: "Sibuyeni", value: "sibuyeni" },
      { label: "Sigombeni", value: "sigombeni" },
      { label: "Ntunja", value: "ntunja" },
      { label: "Vusweni", value: "vusweni" },
    ],
    sandleni: [
      { label: "Gwegwe/ Kontshingila", value: "gwegwe/kontshingila" },
      { label: "KaShiba /Tibondzeni", value: "kashiba/tibondzeni" },
      { label: "Ngololweni", value: "ngololweni" },
      { label: "Nhlentjeni", value: "nhlentjeni" },
      { label: "Nkhungwini", value: "nkhungwini" },
    ],
    "zombodze emuva": [
      { label: "Bulekeni", value: "bulekeni" },
      { label: "Mampondweni", value: "mampondweni" },
      { label: "Ngwenyameni", value: "ngwenyameni" },
      { label: "Zombodze", value: "zombodze" },
    ],
    somntongo: [
      { label: "Etjeni/Ezindwendweni", value: "etjeni/ezindwendweni" },
      { label: "Luhlekweni", value: "luhlekweni" },
      { label: "Maplotini/Lavumisa", value: "maplotini/lavumisa" },
      { label: "Nsubane", value: "nsubane" },
      { label: "Ntuthwakazi", value: "ntuthwakazi" },
      { label: "Phangweni", value: "phangweni" },
      { label: "Vimbizibuko", value: "vimbizibuko" },
    ],
    matsanjeni: [
      { label: "Bhambitje", value: "bhambitje" },
      { label: "Dinabanye", value: "dinabanye" },
      { label: "Kwaluseni/Mgamu", value: "kwaluseni/mgamu" },
      { label: "Nkonka", value: "nkonka" },
      { label: "Nsalitje", value: "nsalitje" },
      { label: "Qomintaba", value: "qomintaba" },
    ],
    sigwe: [
      { label: "Kuphumleni", value: "kuphumleni" },
      { label: "Lulakeni", value: "lulakeni" },
      { label: "Ndunayithini", value: "ndunayithini" },
      { label: "Nyatsini", value: "nyatsini" },
    ],
    "shiselweni 1": [
      { label: "Dumenkhungwini", value: "dumenkhungwini" },
      { label: "Eposini", value: "eposini" },
      { label: "Hhuhhuma", value: "hhuhhuma" },
      { label: "Mabonabulawe", value: "mabonabulawe" },
      { label: "Manyandzeni", value: "manyandzeni" },
      { label: "Mchinsweni", value: "mchinsweni" },
      { label: "Zikhotheni", value: "zikhotheni" },
    ],
    gege: [
      { label: "Dilini", value: "dilini" },
      { label: "Ka-Dinga", value: "ka-dinga" },
      { label: "Ka-Tsambekwako", value: "ka-tsambekwako" },
      { label: "Mashobeni South", value: "mashobeni south" },
      { label: "Mhlahlweni", value: "mhlahlweni" },
      { label: "Mlindazwe", value: "mlindazwe" },
      { label: "Nshamanti", value: "nshamanti" },
      { label: "Nsukazi", value: "nsukazi" },
      { label: "Sidwala", value: "sidwala" },
      { label: "Sisingeni", value: "sisingeni" },
      { label: "Siyendle", value: "siyendle" },
    ],
    maseyisini: [
      { label: "Dlovunga", value: "dlovunga" },
      { label: "KaMzizi", value: "kamzizi" },
      { label: "Masibini", value: "masibini" },
      { label: "Mbilaneni", value: "mbilaneni" },
      { label: "Simemeni", value: "simemeni" },
      { label: "Vusweni", value: "vusweni" },
    ],
    kubuta: [
      { label: "Ezishineni", value: "ezishineni" },
      { label: "KaGwebu", value: "kagwebu" },
      { label: "Kakholwane", value: "kakholwane" },
      { label: "KaNdlovu/ Manyeveni", value: "kandlovu/manyeveni" },
      { label: "Kaphunga", value: "kaphunga" },
      { label: "Ngobolweni", value: "ngobolweni" },
      { label: "Nhlalabantfu", value: "nhlalabantfu" },
    ],
    mtsambama: [
      { label: "Benezer", value: "benezer" },
      { label: "Bhanganoma", value: "bhanganoma" },
      { label: "KaZenzile", value: "kazenzile" },
      { label: "Kwendzeni", value: "kwendzeni" },
      { label: "Magele", value: "magele" },
    ],
    nkwene: [
      { label: "Buseleni", value: "buseleni" },
      { label: "Hlobane", value: "hlobane" },
      { label: "Kuphumleni", value: "kuphumleni" },
      { label: "Nkwene/ Nhlalabantfu", value: "nkwene/nhlalabantfu" },
    ],
    "shiselweni 2": [
      { label: "Mahlalini", value: "mahlalini" },
      { label: "Makhwelela", value: "makhwelela" },
      { label: "Mathendele", value: "mathendele" },
      { label: "Mbabala", value: "mbabala" },
      { label: "Mbangweni", value: "mbangweni" },
      { label: "Mbeka", value: "mbeka" },
      { label: "Mkhitsini", value: "mkhitsini" },
      { label: "Mphangisweni", value: "mphangisweni" },
      { label: "Sikhotseni", value: "sikhotseni" },
    ],
    hosea: [
      { label: "Bufaneni", value: "bufaneni" },
      { label: "Hhohho Emuva", value: "hhohho emuva" },
      { label: "Ludzakeni/Kaliba", value: "ludzakeni/kaliba" },
      { label: "Lushini", value: "lushini" },
      { label: "Manyiseni", value: "manyiseni" },
      { label: "Nsingizini", value: "nsingizini" },
      { label: "Ondiyaneni", value: "ondiyaneni" },
    ],
    ngudzeni: [
      { label: "Ka Mbiko/Mkhaya", value: "ka mbiko/mkhaya" },
      { label: "KaMhawu", value: "kamhawu" },
      { label: "KaMshengu", value: "kamshengu" },
      { label: "Kukhanyeni/Mpini", value: "kukhanyeni/mpini" },
      { label: "Lusitini", value: "lusitini" },
      { label: "Ndushulweni", value: "ndushulweni" },
      { label: "Nokwane", value: "nokwane" },
      { label: "Phobane", value: "phobane" },
    ],
    kumethula: [
      { label: "Gasa", value: "gasa" },
      { label: "Khamsile", value: "khamsile" },
      { label: "Lomfa", value: "lomfa" },
      { label: "Mbabane", value: "mbabane" },
      { label: "Mbangweni", value: "mbangweni" },
      { label: "Nkalaneni", value: "nkalaneni" },
      { label: "KaNkomonye", value: "kankomonye" },
      { label: "KaNzameya", value: "kanzameya" },
    ],
    "matsanjeni north": [
      { label: "Lukhetseni", value: "lukhetseni" },
      { label: "Mambane", value: "mambane" },
      { label: "Maphungwane", value: "maphungwane" },
      { label: "Tikhuba", value: "tikhuba" },
    ],
    mpolonjeni: [
      { label: "Ka Shoba", value: "ka shoba" },
      { label: "Sigcaweni East", value: "sigcaweni east" },
      { label: "Mpolonjeni", value: "mpolonjeni" },
      { label: "Ndzangu", value: "ndzangu" },
      { label: "Ngcina", value: "ngcina" },
    ],
    siphofaneni: [
      { label: "Kamkhweli", value: "kamkhweli" },
      { label: "Madlenya", value: "madlenya" },
      { label: "Maphilingo", value: "maphilingo" },
      { label: "Mphumakudze", value: "mphumakudze" },
      { label: "Nceka", value: "nceka" },
    ],
    dvokodvweni: [
      { label: "Hlane", value: "hlane" },
      { label: "Malindza", value: "malindza" },
      { label: "Mdumezulu", value: "mdumezulu" },
      { label: "Mhlangatane", value: "mhlangatane" },
      { label: "Njabulweni", value: "njabulweni" },
      { label: "Ntandweni", value: "ntandweni" },
    ],
    lugongolweni: [
      { label: "Ka-Langa", value: "ka-langa" },
      { label: "Makhewu", value: "makhewu" },
      { label: "Mlindazwe", value: "mlindazwe" },
      { label: "Sitsatsaweni", value: "sitsatsaweni" },
    ],
    lomahasha: [
      { label: "Lomahasha", value: "lomahasha" },
      { label: "Shewula", value: "shewula" },
      { label: "Mafucula (Mhlume)", value: "mafucula (mhlume)" },
    ],
    lubuli: [
      { label: "Nsoko (Cantebury)", value: "nsoko (cantebury)" },
      { label: "Ka-Vuma", value: "ka-vuma" },
      { label: "Mabantaneni", value: "mabantaneni" },
      { label: "Ntuthwakazi", value: "ntuthwakazi" },
    ],
    sithobela: [
      { label: "Ka Mbiko/Mkhaya", value: "ka mbiko/mkhaya" },
      { label: "KaMhawu", value: "kamhawu" },
      { label: "KaMshengu", value: "kamshengu" },
      { label: "Kukhanyeni/Mpini", value: "kukhanyeni/mpini" },
      { label: "Lusitini", value: "lusitini" },
      { label: "Ndushulweni", value: "ndushulweni" },
      { label: "Nokwane", value: "nokwane" },
      { label: "Phobane", value: "phobane" },
    ],
    nkilongo: [
      { label: "Crooks-Plantations", value: "crooks-plantations" },
      { label: "Gamula", value: "gamula" },
      { label: "Lunkuntfu", value: "lunkuntfu" },
      { label: "Mayaluka/Illovo", value: "mayaluka/illovo" },
      { label: "Nkhanini/Lusabeni", value: "nkhanini/lusabeni" },
      { label: "Phafeni/ Mndobandoba", value: "phafeni/mndobandoba" },
    ],
    mhlume: [
      { label: "Mhlume", value: "mhlume" },
      { label: "Simunye", value: "simunye" },
      { label: "Tabankulu", value: "tabankulu" },
      { label: "Tsambokhulu", value: "tsambokhulu" },
      { label: "Tshaneni", value: "tshaneni" },
      { label: "Vuvulane", value: "vuvulane" },
    ],
    gilgal: [
      { label: "Bulunga", value: "bulunga" },
      { label: "Hlutse", value: "hlutse" },
      { label: "Mabondweni", value: "mabondweni" },
      { label: "Macetjeni", value: "macetjeni" },
      { label: "Sigcaweni West", value: "sigcaweni west" },
      { label: "Tjedze", value: "tjedze" },
    ],
  };
  
  export {
    gender_options,
    ethnicity_options,
    marital_status_options,
    education_level_options,
    occupation_options,
    client_is_handicapped_options,
    country_of_origin_options,
    patient_regions_options,
    inkhulda_options,
    chiefdom_options,
  };
  